import {
  Box,
  IconButton,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

interface OutlineToolbarProps {
  viewMode: 'tree' | 'cards';
  onViewModeChange: (mode: 'tree' | 'cards') => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

export function OutlineToolbar({
  viewMode,
  onViewModeChange,
  searchQuery,
  onSearchChange,
  onExpandAll,
  onCollapseAll,
}: OutlineToolbarProps) {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
      <TextField
        size="small"
        placeholder="Search nodes..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ flex: 1, maxWidth: 300 }}
      />
      <Box sx={{ flex: 1 }} />
      <Tooltip title="Expand all">
        <IconButton size="small" onClick={onExpandAll}>
          <UnfoldMoreIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Collapse all">
        <IconButton size="small" onClick={onCollapseAll}>
          <UnfoldLessIcon />
        </IconButton>
      </Tooltip>
      <ToggleButtonGroup
        size="small"
        value={viewMode}
        exclusive
        onChange={(_, v) => v && onViewModeChange(v)}
      >
        <ToggleButton value="tree">
          <Tooltip title="Tree view">
            <AccountTreeIcon fontSize="small" />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value="cards">
          <Tooltip title="Card view">
            <ViewModuleIcon fontSize="small" />
          </Tooltip>
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
}
